import { useState, useRef, useEffect } from 'react';

export interface InventoryOption {
  id: number;
  name: string;
  costCents: number;
  widthInches?: number | null;
  inventoryType: string;
}

interface Props {
  items: InventoryOption[];
  value: string;
  onChange: (value: string, item?: InventoryOption) => void;
  placeholder?: string;
  disabled?: boolean;
}

export default function InventorySearchSelect({ items, value, onChange, placeholder, disabled }: Props) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState(value);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setQuery(value);
  }, [value]);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const filtered = query
    ? items.filter(i => i.name.toLowerCase().includes(query.toLowerCase()))
    : items;

  return (
    <div ref={containerRef} style={{ position: 'relative' }}>
      <input
        type="text"
        className="input"
        style={{ width: '100%', boxSizing: 'border-box' }}
        value={query}
        placeholder={placeholder}
        disabled={disabled}
        onChange={e => {
          setQuery(e.target.value);
          onChange(e.target.value, undefined);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
      />
      {open && filtered.length > 0 && (
        <ul style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100,
          background: '#fff', border: '1px solid #d1d5db', borderRadius: 6,
          margin: 0, padding: 0, listStyle: 'none',
          maxHeight: 200, overflowY: 'auto',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        }}>
          {filtered.map(item => (
            <li
              key={item.id}
              style={{ padding: '8px 12px', cursor: 'pointer', fontSize: 13, borderBottom: '1px solid #f3f4f6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              onMouseDown={e => e.preventDefault()}
              onClick={() => {
                setQuery(item.name);
                onChange(item.name, item);
                setOpen(false);
              }}
              onMouseEnter={e => (e.currentTarget.style.background = '#f9fafb')}
              onMouseLeave={e => (e.currentTarget.style.background = '')}
            >
              <span style={{ fontWeight: 500 }}>
                {item.name}
                {item.widthInches ? <span style={{ color: '#9ca3af', fontWeight: 400, marginLeft: 6 }}>({item.widthInches}")</span> : null}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
